import flagSchema from "venuescanner-js/constants/user_flags";

// import { postToApi } from 'venuescanner-js/services/api'
import pageUser from "../pageUser";
// import serviceURLs from '../serviceURLs.json'
import controllers from "../controllers";

/** @class
 * @name Flags
 * @desc Class definition of a Users Flags
 * <br>This Object will have the properties as defined by schema in the user_flags file.
 * <br>Updating a valid property will post and update the user immediately, if logged in.
 * <br>If not logged in, then the flags are recorded in localstorage, and then updated once logged in.
 */
class Flags {
  constructor(values = {}, updatedCallback) {
    this._toSend = [];
    this._sendUpdateTimeout = null;
    this._updatedCallback = updatedCallback;
    this._data = {};
    Object.keys(flagSchema).forEach((k) => {
      switch (flagSchema[k].type) {
        case Date:
          this._data[k] = values[k] ? new Date(values[k]) : null;
          Object.defineProperty(this, k, {
            get: function () {
              return this._data[k];
            },
            set: function (v) {
              if (v === true) v = new Date();
              if (v === false) v = null;
              if (this._data[k] != v) {
                this._data[k] = v;
                this._changed({ key: k });
              }
            },
          });
          break;
        case String:
          this._data[k] = values[k] ? values[k] : null;
          Object.defineProperty(this, k, {
            get: function () {
              return this._data[k];
            },
            set: function (v) {
              // console.log(k,v);
              if (flagSchema[k].enum && !flagSchema[k].enum.includes(v)) return;
              if (this._data[k] != v) {
                this._data[k] = v;
                this._changed({ key: k });
              }
            },
          });
          break;
        case Number:
          this._data[k] = values[k] ? values[k] : null;
          Object.defineProperty(this, k, {
            get: function () {
              return this._data[k];
            },
            set: function (v) {
              // console.log(k,v);
              if (flagSchema[k].enum && !flagSchema[k].enum.includes(v)) return;
              if (this._data[k] != v) {
                this._data[k] = v;
                this._changed({ key: k });
              }
            },
          });
          break;
        default:
          this[k] = values[k];
      }
    });
  }

  _sendUpdate() {
    if (this._toSend.length) {
      if (pageUser.user) {
        const data = {
          flags: this._toSend.reduce((acc, key) => {
            acc[key] = this._data[key];
            return acc;
          }, {}),
        };
        this._toSend = [];
        controllers.userService.flags.post(data).then(() => {
          this._toSend = [];
          this._updatedCallback(this);
        });
      } else {
        this._updatedCallback(this);
      }
    }
  }

  _changed({ key }) {
    this._toSend.push(key);
    if (!this._sendUpdateTimeout) {
      this._sendUpdateTimeout = setTimeout(() => {
        this._sendUpdate();
        this._sendUpdateTimeout = null;
      }, 100);
    }
  }

  toJSON() {
    return this._data;
  }
}

export default Flags;
